import { LitElement, css, html, unsafeCSS } from 'lit';
import styles from './notification.scss?inline';
import { ICONS, STATUS } from './constants';

import { createRef, ref } from 'lit/directives/ref.js';

export default class SotbitNotification extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        status: { type: String },
    };

    constructor() {
        super();
        this._itemRef = createRef();
        this.status = STATUS.SUCCESS;
    }

    connectedCallback() {
        super.connectedCallback();

        setTimeout(() => {
            this._itemRef.value.style.opacity = 1;
        }, 0);
    }

    renderIcon() {
        const iconId = ICONS[this.status];

        if (!iconId) {
            return null;
        }

        return html` <sotbit-icon icon="${iconId}"></sotbit-icon> `;
    }

    render() {
        return html`
            <div class="notification">
                <div class="notification-container" ${ref(this._itemRef)}>
                    <div class="notification__content">
                        <div class="notification__icon">${this.renderIcon()}</div>
                        <div class="notification__message-block">
                            <slot name="title" class="notification__title"></slot>
                            <slot name="message" class="notification__message"></slot>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
